import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {SearchService_GetSearchResultsStreamLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {PRODUCTS_PER_PAGE} from '../../../features/ProductStream/constants';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useProtoProductImageType} from '../../../shared-deprecated/useProductImageType';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useSearchToken} from '../SearchPageResolver';
import {useCategoryIdentifier} from './useCategoryIdentifier';

export const useSearchResultsStream = ({token}: {token: string}) => {
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const appliedFilters = useAppliedPotentialFilters();
  const preferredImage = useProtoProductImageType();
  const searchToken = useSearchToken();
  const reductionsState = useReductionsStateRequestParameter();
  const session = useFullSession();
  const categoryIdentifier = useCategoryIdentifier();

  const request = useGrpcRequest(SearchService_GetSearchResultsStreamLazy, {
    continuationToken: token,
    searchToken,
    session,
    reductionsState,
    targetGroup: targetGroupIdentifier,
    elementCount: PRODUCTS_PER_PAGE,
    appliedFilters: {
      filters: appliedFilters,
    },
    preferredProductImageType: preferredImage,
    category: categoryIdentifier ?? null,
  });

  const nextState = request.data?.continuationToken;
  const items = request.data?.sections;

  return {
    ...request,
    data: request.data
      ? {
          ...request.data,
          nextState,
          items,
        }
      : undefined,
  };
};
